module.exports = __webpack_public_path__ + "media/packs/images/upload-document-ac001719974c649d8feb304d41fae91c.svg";